import { customErrorToast } from "ui/custom-toast";

export const apiErrorHandler = ({
  result,
  defaultErrorMsg,
}: {
  result: any;
  defaultErrorMsg: string;
}) => {
  let message = result?.message || defaultErrorMsg;

  if (message?.toLowerCase()?.includes("prisma")) {
    message = defaultErrorMsg;
  }

  if (result?.error) {
    customErrorToast({
      message,
    });
    throw new Error(message);
  }
};
